import { FC, useState } from 'react'
import imageResize from 'project/image-proxy-web'
import Input from 'components/forms/Input'
import Button from 'components/forms/Button'
import { Utils } from 'common/utils'
import EmbededNewsletterForm from 'components/sections/EmbededNewsletterForm'

interface Props {}
const Newsletter: FC<Props> = ({children}) => {
  return <EmbededNewsletterForm>{children}</EmbededNewsletterForm>
}

export default Newsletter
